//https://github.com/amsul/pickadate.js/tree/3.5.6/lib/translations <-- Translations for date picker
$(".pickadate").pickadate({
  // Buttons
  today: 'Today',
  clear: 'Clear',
  close: 'Close',

  // Accessibility labels
  labelMonthNext: 'Next month',
  labelMonthPrev: 'Previous month',

  // Formats
  format: 'dd/mm/yyyy',
  formatSubmit: 'dd/mm/yyyy',
  hiddenName: false,

  // Editable input
  editable: false,

  // Dropdown selectors
  selectYears: false,
  selectMonths: false,

  // First day of the week
  firstDay: 1,

  // Close on a user action
  closeOnSelect: true,
  closeOnClear: false,

  // Limits the choice of date to <= today
  max: true,

  // Prevent datepicker from opening on browser tab change
  onClose: function() {
    $(this).blur();
    console.log('closed')
  },
  onStop: function() {
    console.log("Stopped");
  }
});
